import { Accordion, AccordionHeader, AccordionStatus } from '@dmc/ui';
import { CSSProperties, PropsWithChildren, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

export const ExternalEmailsWrapper = ({ children }: PropsWithChildren): ReactElement => {
  const { t } = useTranslation();

  return (
    // Remove the accordion header background color by overriding the CSS var used by the children.
    <div style={{ '--color-background-general-lowest-default': 'transparent' } as CSSProperties}>
      <Accordion
        defaultExpanded={true}
        hideControl={true}
        status={AccordionStatus.Informative}
        icon="zoom-in"
        header={
          <AccordionHeader
            title={t('Field.ExternalTeamMembers.Label')}
            subtitle={t('Field.ExternalTeamMembers.Description')}
          />
        }
      >
        {children}
      </Accordion>
    </div>
  );
};
